/* "You may also like" slider. Delegated, because theme.js swaps the track in after fetching recommendations. */
(() => {
  if (window.peraanRecSliderReady) return;
  window.peraanRecSliderReady = true;

  const getTrack = (slider) => slider.querySelector('[data-rec-track]');

  const update = (slider) => {
    const track = getTrack(slider);
    const prev = slider.querySelector('[data-rec-prev]');
    const next = slider.querySelector('[data-rec-next]');
    if (!track || !prev || !next) return;

    const maxScroll = track.scrollWidth - track.clientWidth;
    slider.classList.toggle('is-static', maxScroll <= 2);
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= maxScroll - 2;
  };

  const updateAll = () => document.querySelectorAll('[data-rec-slider]').forEach(update);

  document.addEventListener('click', (evt) => {
    const button = evt.target.closest('[data-rec-prev], [data-rec-next]');
    if (!button) return;
    const slider = button.closest('[data-rec-slider]');
    const track = slider && getTrack(slider);
    if (!track) return;

    const slide = track.querySelector('.grid__item');
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
    const perPage = Math.max(1, Math.floor((track.clientWidth + gap) / step));
    const direction = button.hasAttribute('data-rec-prev') ? -1 : 1;

    track.scrollBy({ left: direction * step * perPage, behavior: 'smooth' });
  });

  // Scroll events don't bubble, so listen in the capture phase
  document.addEventListener('scroll', (evt) => {
    const track = evt.target;
    if (!(track instanceof Element) || !track.matches('[data-rec-track]')) return;
    const slider = track.closest('[data-rec-slider]');
    if (slider) update(slider);
  }, { capture: true, passive: true });

  document.addEventListener('recommendations:loaded', () => requestAnimationFrame(updateAll));
  window.addEventListener('resize', updateAll, { passive: true });
  window.addEventListener('load', updateAll);
  updateAll();
})();
